import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(_ctx.classes),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dispatchInputEvent && _ctx.dispatchInputEvent(...args)))
  }, null, 2))
}